import { gql } from 'graphql-request';
import type { SiteStatus } from './siteStatus';

export const siteNatureRiskOverviewQuery = gql`
    query GetSiteNatureRiskOverview($organisationBusinessCentralId: String!, $siteId: ID!, $at: DateTime) {
        site(organisationBusinessCentralId: $organisationBusinessCentralId, siteId: $siteId, at: $at) {
            id
            name
            status
            validTo
            geography {
                countryName
            }
            activity {
                isicDetail {
                    code
                    description
                }
            }
            portfolioRank {
                rank
                total
            }
            dependencyRank {
                rank
                total
            }
            impactRank {
                rank
                total
            }
            riskSummary {
                physicalNatureRisk
                operationalDependencies
                impactsOnNature
                stateOfNature
            }
            natureStatus
            materialityBreakdown {
                name
                sourceKey
                materialityType
                score
            }
        }
    }
`;

export type SiteNatureRiskOverviewResult = {
    site: {
        id: string;
        name: string;
        status: SiteStatus;
        validTo: string | null;
        geography: {
            countryName: string | null;
        } | null;
        activity: {
            isicDetail: { code: string; description: string } | null;
        } | null;
        portfolioRank: {
            rank: number;
            total: number;
        } | null;
        dependencyRank: {
            rank: number;
            total: number;
        } | null;
        impactRank: {
            rank: number;
            total: number;
        } | null;
        riskSummary: {
            physicalNatureRisk: number | null;
            operationalDependencies: number | null;
            impactsOnNature: number | null;
            stateOfNature: number | null;
        } | null;
        natureStatus: string | null;
        materialityBreakdown: {
            name: string;
            sourceKey: string;
            materialityType: 'Dependency' | 'Impact';
            score: number;
        }[];
    } | null;
};
